// extracted by mini-css-extract-plugin
module.exports = {"main":"ContentBox_main__1NEgF","content":"ContentBox_content__J-cbr"};